import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TaskReducer } from './reducer';
import { TaskEffects } from './effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('task', TaskReducer),
    EffectsModule.forFeature([TaskEffects])
  ]
})
export class TaskStoreModule { }
